import BenchlingConfig from 'BenchlingConfig';
import PipelineNodeAdapter from 'pipelines/processes-platform/PipelineNodeAdapter';
import * as ProcessSchemaDAO from 'processes/dao/ProcessSchemaDAO';
import {
  ProcessesPluginBase,
  ProcessesPluginMetadataEditorItem,
} from 'processes/graph-builder-processes/platform/ProcessesPluginBase';
import {
  DirectExecutionTaskSchemaNodeAdapter,
  EntryExecutionTaskSchemaNodeAdapter,
  FlowchartExecutionTaskSchemaNodeAdapter,
} from 'processes/graph-builder-processes/processes-plugin/TaskSchemaNodeAdapters';
import {FlowchartSettingsSidepanelContent} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/left-sidepanel/FlowchartSettingsSidepanelContent';
import {ProcessFlowchartConfigEditorHeaderConfig} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/ProcessFlowchartConfigEditorHeaderTypes';
import {DefaultProcessTaskSchemaHeaderActions} from 'processes/settings/ProcessTaskSchemaEditor';
import {SidepanelSize} from 'ui-library/reactflow/sidepanels/FlowchartContextPanel';

import {ProcessFlowchartNodeAdapter} from '../flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {ProcessFlowchartValidator} from '../flowchart-viz/horizontal-flowchart/ProcessFlowchartValidator';
import {FlowchartValidator} from '../platform/FlowchartValidator';
import {RouterNodeAdapter, StopNodeAdapter} from './LogicNodeAdapters';

export class DefaultProcessesPlugin extends ProcessesPluginBase {
  // Keep in sync with benchling/processes/processes_platform/plugins/default_processes_flowchart_configurator.py
  static readonly FLOWCHART_TYPE_NAME = 'DEFAULT_PROCESSES';

  readonly pluginName: string = 'DefaultProcessesPlugin';
  readonly flowchartTypeName: string = DefaultProcessesPlugin.FLOWCHART_TYPE_NAME;

  readonly nodeAdapters: Array<ProcessFlowchartNodeAdapter> = [
    new DirectExecutionTaskSchemaNodeAdapter(),
    new EntryExecutionTaskSchemaNodeAdapter(),
    new FlowchartExecutionTaskSchemaNodeAdapter(),
    new RouterNodeAdapter(),
    new StopNodeAdapter(),
    ...(BenchlingConfig.WORKFLOWS_ENABLE_PIPELINE_NODES ? [new PipelineNodeAdapter()] : []),
  ];

  readonly flowchartValidator: FlowchartValidator = new ProcessFlowchartValidator();

  readonly metadataEditor: ProcessesPluginMetadataEditorItem = {
    icon: 'settings',
    name: 'Flowchart settings',
    editorComponent: FlowchartSettingsSidepanelContent,
    width: SidepanelSize.FULL,
  };

  override readonly headerConfig: ProcessFlowchartConfigEditorHeaderConfig = {
    icon: 'process',
    breadcrumbItems: [
      {
        label: 'Task Schemas',
        href: ProcessSchemaDAO.processTaskSchemasURL(),
      },
    ],
    actionsComponent: DefaultProcessTaskSchemaHeaderActions,
  };
}
